(function () {
    "use strict";

    HGifSelectorComponent.$inject = ['$scope'];

    function HGifSelectorComponent($scope) {

        var self = this;

        self.$onInit = function () {
            self.giphySelectorDirection = self.giphySelectorDirection ? self.giphySelectorDirection : 'up';
        };

        self.openGifsDialog = function () {
            self.onOpenDialog();
            self.showGifsSelector = true;
            setTimeout(function () {
                $(document).on("click.add-gif", function (event) {
                    if ($(event.target).parents(".h-gif-selector-component").length === 0) {
                        closeGifsDialog();
                        $scope.$digest();
                    }
                });
            }, 1);
        };

        var closeGifsDialog = function () {
            self.showGifsSelector = false;
            $(document).off("click.add-gif");
        };

        self.selectGif = function (data) {
            closeGifsDialog();
            self.onGifSelected({data: data});
        };

        self.$onChanges = function () {

        };

        self.$onDestroy = function () {

        };
    }

    var HGifSelectorComponentOptions = {
        bindings: {
            onGifSelected: '&',
            onOpenDialog: '&',
            giphySelectorDirection: '<?',
            appendToHRichText: '<?',
        },
        controller: HGifSelectorComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-gifs/h-gif-selector/h-gif-selector.component.html'
    };

    angular
        .module('components')
        .component('hGifSelector', HGifSelectorComponentOptions);
})();
